import { inject } from '@angular/core'
import { CanMatchFn, Router } from '@angular/router'

// Temporary suspension: restore the menu and route together after the NVR incident.
export const CAMERAS_ENABLED = false

export const camerasAvailabilityGuard: CanMatchFn = () =>
  CAMERAS_ENABLED || inject(Router).parseUrl('/')
